// extracted by mini-css-extract-plugin
module.exports = {"with-back-button":"WithBackButton_with-back-button__QNAEa","content":"WithBackButton_content__CToqd"};